import { Platform } from 'react-native';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/gab-ai/id6759009193';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=ai.gab.gabaiapp';

export function openStoreUrl(url) {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    // eslint-disable-next-line global-require
    const { Linking } = require('react-native');
    Linking.openURL(url);
  }
}
